import { httpApi as httpNodeApi } from '@nucleus-care/nucleuscare-backend-client';

export interface DeviceTimezone {
  DeviceID: string;
  DeviceName: string | null;
  GmtOffset: number | null;
  Code: string | null;
  Name: string | null;
  NextOffsetChange: string | null;
  LocationUpdatedDate: string | null;
  CacheLastRefreshDate: string | null;
}

export interface DeviceTimezoneOverridePayload {
  GmtOffset: number;
  Code: string;
  Name?: string;
  NextOffsetChange?: string;
}

export interface ApiResult {
  ok: boolean;
  status?: number;
  [key: string]: unknown;
}

class DeviceTimezoneApi {
  async getAccountDeviceTimezones(accountId: string): Promise<ApiResult & { data?: DeviceTimezone[] }> {
    try {
      const response = await httpNodeApi.get(`/device/account/${accountId}/timezones`);
      return { ok: true, status: response.status, ...response.data };
    } catch (error) {
      const errorData = error.response?.data || { error: 'Network Error on getAccountDeviceTimezones' };
      return { ok: false, status: error.response?.status || 500, ...errorData };
    }
  }

  async overrideDeviceTimezone(deviceId: string, payload: DeviceTimezoneOverridePayload): Promise<ApiResult & { data?: DeviceTimezone }> {
    try {
      const response = await httpNodeApi.put(`/device/${deviceId}/timezone`, payload);
      return { ok: true, status: response.status, ...response.data };
    } catch (error) {
      const errorData = error.response?.data || { error: 'Network Error on overrideDeviceTimezone' };
      return { ok: false, status: error.response?.status || 500, ...errorData };
    }
  }
}

const deviceTimezoneApi = new DeviceTimezoneApi();
export default deviceTimezoneApi;
